import { useEffect, useMemo, useState } from 'react';
import {
  getPlatform,
  isMobile as isMobileUtil,
  isPC as isPcUtil,
  type PLATFORM,
} from '~/utils/user-agent';

export const useUserAgent = () => {
  const [platform, setPlatform] = useState<PLATFORM>();

  const isMobile = useMemo(() => {
    if (!platform) return;

    return isMobileUtil(platform);
  }, [platform]);

  const isPC = useMemo(() => {
    if (!platform) return false;

    return isPcUtil(platform);
  }, [platform]);

  useEffect(() => {
    setPlatform(getPlatform(window.navigator.userAgent));
  }, []);

  return {
    platform,
    isMobile,
    isPC,
  };
};
